var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatflo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logos",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 417.68 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#051c2c;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:#e21d7a;}.cls-5{fill:#af2185;}.cls-6{fill:#293a89;}.cls-7{fill:#158eb2;}.cls-8{fill:#3db8c0;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.99,
    y: 40,
    width: 40,
    height: 120
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Color Logo Black Text Transparent Background") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Colour_Logo_Black_Text_Transparent",
    "data-name": "Colour Logo Black Text Transparent"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Statflo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108.9,117.86c-.64-.51-.89-.89-.32-1.91l2.29-3.94a1.47,1.47,0,0,1,2.16-.44c2.6,2,5.46,3.94,9.59,3.94,3.31,0,5.79-2.16,5.79-4.9,0-3.24-2.74-5.46-8.07-7.62-6-2.42-12-6.23-12-13.73,0-5.66,4.19-12.2,14.3-12.2a22.41,22.41,0,0,1,12.71,4.25,1.59,1.59,0,0,1,.38,2.1L133.37,87a1.68,1.68,0,0,1-2.23.77c-2.73-1.72-5.34-3.5-8.83-3.5s-5.6,2-5.6,4.45c0,3,2.36,5,7.5,7.12,6.17,2.48,13.29,6.16,13.29,14.36,0,6.55-5.66,12.59-14.62,12.59C114.87,122.82,110.74,119.45,108.9,117.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M155.74,85.32H146a1.21,1.21,0,0,1-1.21-1.21V78.9A1.21,1.21,0,0,1,146,77.69h27.77A1.21,1.21,0,0,1,175,78.9v5.21a1.21,1.21,0,0,1-1.21,1.21h-9.72V121a1.26,1.26,0,0,1-1.21,1.21H157a1.25,1.25,0,0,1-1.21-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M177.16,120.53l19.77-42.77a1.12,1.12,0,0,1,1.08-.7h.63a1.07,1.07,0,0,1,1.08.7l19.58,42.77a1.12,1.12,0,0,1-1.08,1.65h-5.53a1.83,1.83,0,0,1-1.85-1.27l-3.11-6.86h-19l-3.12,6.86a1.9,1.9,0,0,1-1.84,1.27h-5.53A1.12,1.12,0,0,1,177.16,120.53ZM204.62,107l-6.36-14h-.19l-6.23,14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M232.39,85.32h-9.72a1.21,1.21,0,0,1-1.21-1.21V78.9a1.21,1.21,0,0,1,1.21-1.21h27.77a1.21,1.21,0,0,1,1.21,1.21v5.21a1.21,1.21,0,0,1-1.21,1.21h-9.72V121a1.25,1.25,0,0,1-1.21,1.21H233.6a1.26,1.26,0,0,1-1.21-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M261.88,78.9a1.21,1.21,0,0,1,1.21-1.21H289a1.21,1.21,0,0,1,1.21,1.21v5.21A1.21,1.21,0,0,1,289,85.32H270.15v12h15.7a1.24,1.24,0,0,1,1.2,1.2v5.22a1.24,1.24,0,0,1-1.2,1.2h-15.7V121a1.26,1.26,0,0,1-1.21,1.21h-5.85a1.21,1.21,0,0,1-1.21-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300.47,78.9a1.2,1.2,0,0,1,1.2-1.21h5.85a1.25,1.25,0,0,1,1.21,1.21v35.65h16.2a1.21,1.21,0,0,1,1.21,1.21V121a1.21,1.21,0,0,1-1.21,1.21H301.67a1.2,1.2,0,0,1-1.2-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M354.81,77.06A22.88,22.88,0,1,1,332,100,22.84,22.84,0,0,1,354.81,77.06Zm0,37.49A14.62,14.62,0,1,0,340.25,100,14.64,14.64,0,0,0,354.81,114.55Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Colour_Logo",
    "data-name": "Colour Logo"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 45.85,
    y: 45.86,
    width: 28.28,
    height: 28.28,
    transform: "translate(-24.86 59.99) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "39.99 100 59.99 80 39.99 60 39.99 100"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 45.85,
    y: 85.86,
    width: 28.28,
    height: 28.28,
    transform: "translate(-53.14 71.71) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "59.99 120 79.99 140 79.99 100 59.99 120"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 45.85,
    y: 125.86,
    width: 28.28,
    height: 28.28,
    transform: "translate(-81.42 83.43) rotate(-45)"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_Box",
    "data-name": "Bounding Box",
    className: "cls-1",
    width: 417.68,
    height: 200
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatflo);
export default __webpack_public_path__ + "static/media/statflo.bf653b4c40cfb93e7fd5b53bdd37cab3.svg";
export { ForwardRef as ReactComponent };